import { render, staticRenderFns } from "./SupplierRawMaterialGeneticallyModifiedOrganisms.vue?vue&type=template&id=7d838c8f&scoped=true&"
import script from "./SupplierRawMaterialGeneticallyModifiedOrganisms.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialGeneticallyModifiedOrganisms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d838c8f",
  null
  
)

export default component.exports